import React, { useEffect } from 'react'

// redux
import { useSelector } from "react-redux"
import darkLogo from '../../../assets/clientsidedark.png'
import lightLogo from '../../../assets/client-side-light.png'

// assets
// import LogoDark from "../../../assets/icons/wen-logos/wen-header-dark.svg"
// import LogoLight from "../../../assets/icons/wen-logos/wen-header-light.svg"

function WenbitLogo({ size = 120, style, ...rest }) {
  const theme = useSelector((state) => state.theme.value)
  const exchangeName = useSelector((state) => state.exchangeCustomization.value.name)
  const assets = useSelector(state => state.exchangeAssets.value)

  return (
    <img
      src={theme === 'dark' ? darkLogo : lightLogo}
      alt={exchangeName}
      style={{
        width: size,
        ...style
      }}
      {...rest}
    />
  )
}

export default WenbitLogo
